const SOCIALS = [
  { href: "https://www.instagram.com/georgemapleofficial/", label: "Instagram" },
  { href: "https://www.youtube.com/channel/UCQfErx61BDmkCaluWpt_tew", label: "YouTube" },
  { href: "https://open.spotify.com/artist/19m3oZKjGSLzVW0OGIAcNg", label: "Spotify" },
  { href: "https://music.apple.com/au/artist/george-maple/646956019", label: "Apple Music" },
];

/*
 * SocialRow — subtle vintage-caps row of social links. Matches the existing
 * "CONTACT" / "EMAIL SIGN UP" typography rather than using icons.
 */
export default function SocialRow({ className = "" }) {
  return (
    <div
      className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-2 sm:gap-x-6 ${className}`}
      data-testid="social-row"
    >
      {SOCIALS.map(({ href, label }, i) => (
        <span key={label} className="inline-flex items-center gap-4 sm:gap-6">
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="vintage-link text-[10px] sm:text-[11px] uppercase opacity-70 hover:opacity-100"
            data-testid={`social-${label.toLowerCase().replace(/\s+/g, "-")}`}
          >
            {label}
          </a>
          {i < SOCIALS.length - 1 && (
            <span className="text-white/25 text-[10px] hidden sm:inline">·</span>
          )}
        </span>
      ))}
    </div>
  );
}
